import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as TaskTypeActions from './actions';
import { environment } from 'src/environments/environment';
import { IRule } from '@app/models/rule.model';
import { HttpService } from '@surveyname/common';


@Injectable()
export class RuleEffects {
  constructor(private http: HttpService, private action$: Actions) { }
  GetRules$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(TaskTypeActions.GetRulesAction),
      mergeMap(action =>
        this.http.get(`${environment.apiUrl}/rule/project-type/${action.payload.projectTypeId}`).pipe(
          map((rules: IRule[]) => {
            return TaskTypeActions.RulesLoadedAction({ payload: rules });
          }),
          catchError((error: Error) => {
            return of(TaskTypeActions.ErrorRulesAction(error));
          })
        )
      )
    )
  );

  AddRule$: Observable<Action> = createEffect(() =>
  this.action$.pipe(
    ofType(TaskTypeActions.BeginAddRuleAction),
    mergeMap(action =>
      this.http.post(`${environment.apiUrl}/rule`, action.payload.rule).pipe(
        map((rule: IRule) => {
          return TaskTypeActions.AddRuleFinishedAction({ payload: rule });
        }),
        catchError((error: Error) => {
          return of(TaskTypeActions.ErrorRulesAction(error));
        })
      )
    )
  )
);

EditRule$: Observable<Action> = createEffect(() =>
this.action$.pipe(
  ofType(TaskTypeActions.BeginEditRuleAction),
  mergeMap(action =>
    this.http.put(`${environment.apiUrl}/rule/${action.payload.rule._id}`, action.payload.rule).pipe(
      map((rule: IRule) => {
        return TaskTypeActions.AddRuleFinishedAction({ payload: rule });
      }),
      catchError((error: Error) => {
        return of(TaskTypeActions.ErrorRulesAction(error));
      })
    )
  )
)
);

RemoveRule$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(TaskTypeActions.BeginRemoveRuleAction),
      mergeMap(action =>
        this.http.delete(`${environment.apiUrl}/rule/${action.payload._id}`).pipe(
          map(() => {

            return TaskTypeActions.RemoveRuleAction({ payload: action.payload });
          }),
          catchError((error: Error) => {
            return of(TaskTypeActions.ErrorRulesAction(error));
          })
        )
      )
    )
  );
}

